import { Box, Grid } from "@mui/material";
import styled from "styled-components";


export const ChatLayoutContainer = styled(Box)`
`;

export const ChatContent = styled(Grid)`
justify-content:center`;